module.exports = __webpack_public_path__ + "static/media/mdb.7be2935c.css";


//////////////////
// WEBPACK FOOTER
// ./node_modules/mdbreact/dist/css/mdb.css
// module id = 161
// module chunks = 0